import axios from 'axios';
import API_CONFIG from '../config/api.config';
import { getAuthHeader } from './authService';

const BASE_URL = `${API_CONFIG.BASE_URL}/companies`;

export const companySettingsService = {
  // Get current company settings
  getSettings: async () => {
    try {
      const response = await axios.get(`${BASE_URL}/settings`, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching company settings:', error);
      throw error;
    }
  },

  // Update company settings
  updateSettings: async (settings) => {
    try {
      const response = await axios.put(`${BASE_URL}/settings`, settings, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Error updating company settings:', error);
      throw error;
    }
  }
};

export default companySettingsService; 